module.exports = __webpack_public_path__ + "img/chart_icon_selected.d6d2a35c.svg";